// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   FetchCategoryApi,
//   FetchProductByIdApi,
// } from "../../ApiCalls/AddProducts";
// import ProductImagesGrid from "../ProductImagesGrid/ProductImagesGrid";
// import ReviewCard from "../ReviewCard/ReviewCard";
// import { FetchReviewApi } from "../../ApiCalls/Review";
// import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

// const ProductView = () => {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const [product, setProduct] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [category, setCategory] = useState(null);
//   const [reviews, setReviews] = useState(null);
//   // fetch review
//   const fetchReview = async () => {
//     try {
//       const response = await FetchReviewApi({ id });
//       setReviews(response.data?.Data || []);
//     } catch (err) {
//       console.error("Error fetching reviews:", err);
//       setError("Failed to fetch reviews.");
//     }
//   };

//   //fetch category
//   const fetchCategory = async (categoryId) => {
//     try {
//       const response = await FetchCategoryApi({ categoryId });
//       setCategory(response.Data[0]);
//       // console.log("category", response);
//     } catch (err) {
//       console.error("Error fetching category:", err);
//       setError("Failed to fetch category.");
//     }
//   };

//   useEffect(() => {
//     const fetchProduct = async () => {
//       try {
//         const response = await FetchProductByIdApi({ id });
//         setProduct(response.Data[0]);
//       } catch (err) {
//         setError(err.message);
//         console.error("Error fetching product:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchProduct();
//     fetchReview();
//   }, [id]);

//   useEffect(() => {
//     if (product?.category) {
//       fetchCategory(product.category);
//     }
//   }, [product]);

//   const renderStars = (rating) => {
//     const filledStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 >= 0.5;
//     const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0);

//     return (
//       <>
//         {[...Array(filledStars)].map((_, index) => (
//           <FaStar key={`filled-${index}`} className="h-5 w-5 text-yellow-500" />
//         ))}
//         {hasHalfStar && <FaStarHalfAlt className="h-5 w-5 text-yellow-500" />}
//         {[...Array(emptyStars)].map((_, index) => (
//           <FaRegStar key={`empty-${index}`} className="h-5 w-5 text-gray-400" />
//         ))}
//       </>
//     );
//   };
//   const product_rating = product?.product_rating;
//   const totalStars = 5;
//   if (loading) return <div>Loading...</div>;
//   // if (error) return <div>Error: {error}</div>;

//   return (
//     <div className="grid grid-cols-1 justify-around space-y-2 md:grid-cols-2">
//       {/* image  */}
//       <div className="space-y-2">
//         <ProductImagesGrid productImages={product?.product_images} />
//         {/* product name and rating  */}
//         <div className="space-y-2">
//           <h2 className="text-2xl font-medium">
//             {product?.name || "Product Name Not Available"}
//           </h2>
//           {/* <p>Stars: 4.9 (374 reviews)</p> */}
//           <div className="flex gap-2">
//             {renderStars(product_rating)}
//             <p className="ml-2 text-sm text-gray-500">
//               {product?.product_rating} ({product?.product_review_count}{" "}
//               Reviews)
//             </p>
//           </div>
//           <p className="space-x-2">
//             <span className="text-xl text-red-500">
//               -{product.offer_percent || 0}% off
//             </span>
//             <span className="text-3xl font-bold">
//               {" "}
//               ₹ {product.price || "N/A"}{" "}
//             </span>
//             <span className="text-xl text-gray-500 line-through">
//               ₹{product.actual_price || "N/A"}
//             </span>
//           </p>
//         </div>
//       </div>
//       {/* left product details  */}
//       <div className="product-details ">
//         <div className=" space-y-2 px-3">
//           {/* description  */}
//           <h2 className="text-lg font-medium">Product Description</h2>
//           <p className="pl-2 pr-20 text-gray-700">
//             {product.description} Lorem ipsum, dolor sit amet consectetur
//             adipisicing elit. Nisi praesentium iste quidem temporibus dolor,
//             earum deserunt! Error libero, a quam laboriosam natus, aliquid
//             voluptatem nobis commodi modi non, explicabo exercitationem.
//           </p>
//           <p className="text-gray-700">
//             Transportation Fee :{" "}
//             <span className="text-lg font-medium text-black">
//               ₹ {product.delivery_charge || "N/A"}
//             </span>{" "}
//           </p>
//           <p className="text-gray-700">
//             Stock :{" "}
//             <span className="text-lg font-medium text-black">
//               {product.stock_status ? "In Stock" : "Out of Stock"}
//             </span>
//           </p>
//           <p className="text-gray-700">Brand Name</p>
//           <p className="w-3/4 border p-2">{product.brand || "N/A"}</p>
//           <p className="text-gray-700">Minimum no of quantity</p>
//           <p className="flex gap-5">
//             <div className="w-20 border p-4">{product.min_order_quantity}</div>
//             <div className="w-20 border p-4">
//               {product.min_order_quantity_two}
//             </div>
//             <div className="w-20 border p-4">
//               {product.min_order_quantity_three}
//             </div>
//             <div className="w-20 border p-4">
//               {product.min_order_quantity_four}
//             </div>
//             <div className="w-20 border p-4">
//               {product.min_order_quantity_five}
//             </div>
//           </p>
//           <p className="text-gray-700">Category</p>
//           <p className="w-3/4 border p-2">{category?.name || "N/A"} </p>
//           <p className="text-gray-700">Sub Category</p>
//           <p className="w-3/4 border p-2">
//             {category?.subcategories
//               ?.filter((subcat) => subcat.id === product?.subcategory)
//               ?.map((subcat) => <span key={subcat.id}>{subcat.name}</span>) ||
//               "No subcategories available."}
//           </p>
//         </div>
//         <div className="mt4" style={{ marginTop: '2rem' }}>
//           <button
//             onClick={() => navigate(`/seller_products/edit/${product.id}`)}
//             className="w-3/4 rounded-lg bg-brand-button-green-bg p-2 text-white"
//           >
//             Edit
//           </button>
//         </div>
//       </div>

//       {/* review section  */}
//       <div>
//         <div className="mt-1 flex items-center space-x-1 sm:mt-2">
//           {renderStars(product_rating)}
//           <p className="ml-2 text-sm text-gray-500">
//             {product?.product_rating} ({product?.product_review_count} Reviews)
//           </p>
//         </div>
//         <div>
//           <div className="h-52 overflow-y-auto">
//             {reviews && reviews.length > 0 ? (
//               reviews.map((review, index) => (
//                 <ReviewCard
//                   key={index}
//                   review={review}
//                   renderStars={renderStars}
//                 />
//               ))
//             ) : (
//               <p>No reviews available.</p>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductView;

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  FetchCategoryApi,
  FetchProductByIdApi,
} from "../../ApiCalls/AddProducts";
import ProductImagesGrid from "../ProductImagesGrid/ProductImagesGrid";
import ReviewCard from "../ReviewCard/ReviewCard";
import { FetchReviewApi } from "../../ApiCalls/Review";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { USER_URL } from "../../constant/api";

const ProductView = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [category, setCategory] = useState(null);
  const [reviews, setReviews] = useState(null);
  const [brand, setBrand] = useState(null);
  // fetch review
  const fetchReview = async () => {
    try {
      const response = await FetchReviewApi({ id });
      setReviews(response?.Data || []);
    } catch (err) {
      console.error("Error fetching reviews:", err);
      setError("Failed to fetch reviews.");
    }
  };

  const fetchBrand = async (brandId) => {
    try {
      console.log("brandId", brandId);
      
      const response = await USER_URL.get(
        `products/seller/brand/${brandId}/`,
      );
      console.log("brand", response.data);
      setBrand(response.data.Data);
    } catch (err) {
      console.error("Error fetching brand:", err);
      // setError("Failed to fetch brand.");
    }
  };

  //fetch category
  const fetchCategory = async (categoryId) => {
    try {
      const response = await FetchCategoryApi({ categoryId });
      setCategory(response.Data[0]);
      console.log("category", response?.subcategories);
    } catch (err) {
      console.error("Error fetching category:", err);
      setError("Failed to fetch category.");
    }
  };
  const fetchProduct = async () => {
    try {
      const response = await FetchProductByIdApi({ id });
      setProduct(response.Data[0]);
      console.log("produ", response);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching product:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchProduct();
      fetchReview();
    }
  }, [id]);

  useEffect(() => {
    if (product?.category) {
      fetchCategory(product.category);
      
    }
    if (product?.brand) {
      fetchBrand(product.brand);
    }
  }, [product?.category, product?.brand]);

  const renderStars = (rating) => {
    const filledStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0);

    return (
      <>
        {[...Array(filledStars)].map((_, index) => (
          <FaStar key={`filled-${index}`} className="h-5 w-5 text-yellow-500" />
        ))}
        {hasHalfStar && <FaStarHalfAlt className="h-5 w-5 text-yellow-500" />}
        {[...Array(emptyStars)].map((_, index) => (
          <FaRegStar key={`empty-${index}`} className="h-5 w-5 text-gray-400" />
        ))}
      </>
    );
  };
  const product_rating = product?.product_rating;
  const totalStars = 5;
  if (loading) return <div>Loading...</div>;
  // if (error) return <div>Error: {error}</div>;

  return (
    <div className="h-full w-full p-2">
      <h1 className="mb-4 text-center text-2xl font-bold text-green-600">
        Product View
      </h1>
      <div className="grid grid-cols-1 justify-around space-y-2 md:grid-cols-2">
        {/* image  */}
        <div className="space-y-2">
          <ProductImagesGrid productImages={product?.product_images} />
          {/* product name and rating  */}
          <div className="space-y-2">
            <h2 className="text-2xl font-medium">
              {product?.name || "Product Name Not Available"}
            </h2>
            {/* <p>Stars: 4.9 (374 reviews)</p> */}
            <div className="flex gap-2">
              {renderStars(product_rating)}
              <p className="ml-2 text-sm text-gray-500">
                {product?.product_rating} ({product?.product_review_count}{" "}
                Reviews)
              </p>
            </div>
            <p className="space-x-2">
              <span className="text-xl text-red-500">
                -{product.offer_percent || 0}% off
              </span>
              <span className="text-3xl font-bold">
                {" "}
                {product.currency_symbol}{product.price || "N/A"}{" "}
              </span>
              <span className="text-xl text-gray-500 line-through">
                {product.currency_symbol} {product.actual_price || "N/A"}
              </span>
            </p>
            {/* description  */}
            <h2 className="text-lg font-medium">Product Description</h2>
            <p className="pl-2 pr-20 text-gray-700">
              {product.description} Lorem ipsum, dolor sit amet consectetur
              adipisicing elit. Nisi praesentium iste quidem temporibus dolor,
              earum deserunt! Error libero, a quam laboriosam natus, aliquid
              voluptatem nobis commodi modi non, explicabo exercitationem.
            </p>
          </div>
        </div>
        {/* left product details  */}
        <div className="product-details">
          <div className="space-y-2 px-3">
            <p className="text-gray-700">
              Transportation Fee :{" "}
              <span className="text-lg font-medium text-black">
                {product.currency_symbol} {product.delivery_charge || "N/A"}
              </span>{" "}
            </p>
            <p className="text-gray-700">
              Stock :{" "}
              <span className="text-lg font-medium text-black">
                {product.stock_status ? "In Stock" : "Out of Stock"}
              </span>
            </p>
            <p className="text-gray-700">Brand Name</p>
            <p className="w-3/4 border p-2">{brand?.brandname|| "N/A"}</p>
            <p className="text-gray-700">Minimum no of quantity</p>
            <p className="flex gap-5">
              <div className="w-20 border p-4">
                {product.min_order_quantity}
              </div>
              <div className="w-20 border p-4">
                {product.min_order_quantity_two}
              </div>
              <div className="w-20 border p-4">
                {product.min_order_quantity_three}
              </div>
              <div className="w-20 border p-4">
                {product.min_order_quantity_four}
              </div>
              <div className="w-20 border p-4">
                {product.min_order_quantity_five}
              </div>
            </p>
            <p className="text-gray-700">Category</p>
            <p className="w-3/4 border p-2">{category?.name || "N/A"} </p>
            <p className="text-gray-700">Sub Category</p>
            <p className="w-3/4 border p-2">
              {category?.subcategories?.length > 0
                ? category.subcategories.find(
                    (subcat) => subcat.id === product?.subcategory,
                  )?.name || "No subcategory found"
                : "No subcategories available."}
            </p>
            <p>Stock : {product.stock}</p>
          </div>
          <div className="mt4" style={{ marginTop: "2rem" }}>
            <button
              onClick={() => navigate(`/seller/products/edit/${product.id}`)}
              className="w-3/4 rounded-lg bg-brand-button-green-bg p-2 text-white"
            >
              Edit
            </button>
          </div>
        </div>

        {/* review section  */}
        <div>
          <div className="mt-1 flex items-center space-x-1 sm:mt-2">
            {renderStars(product_rating)}
            <p className="ml-2 text-sm text-gray-500">
              {product?.product_rating} ({product?.product_review_count}{" "}
              Reviews)
            </p>
          </div>
          <div>
            <div className="h-52 overflow-y-auto">
              {reviews && reviews.length > 0 ? (
                reviews.map((review, index) => (
                  <ReviewCard
                    key={index}
                    review={review}
                    renderStars={renderStars}
                  />
                ))
              ) : (
                <p>No reviews available.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductView;
